module.exports = __webpack_public_path__ + "static/media/7p.3a030e70.png";